
module.exports = {
  StaticBaseUrl : "https://static.menubyte.it"
};
